import React from 'react'
import SuccessGreenSvg from '../../../assets/icons/SuccessGreenSvg'
import CarGreenSvg from '../../../assets/icons/CarGreenSvg'
import HistoryIconSvg from '../../../assets/icons/HistoryIconSvg'
import ModalButton from '../BarrierErrorModal/ModalButton'

const SuccessModalBody = ({ toggle, navigate, selectedTesis }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '.8rem',
        padding: '.6rem 0 0 0',
      }}
    >
      <SuccessGreenSvg width={'4rem'} />
      <div
        style={{
          fontSize: '20px',
          fontWeight: '700',
          color: '#205c42',
        }}
      >
        İşlem başarılı
      </div>
      <div
        style={{
          lineHeight: 1,
          margin: 'auto',
          color: '#205c42',
          fontWeight: '300',
        }}
      >
        Misafir yetkilendirme işlemi tamamlanmıştır.
      </div>
      <div style={{ width: '100%' }}>
        <ModalButton
          backgroundColor={'#fff'}
          color={'#205c42'}
          text={'Yeni Misafir Tanımla'}
          border={'1px solid #205c42'}
          margin={'.8rem 0 0 0'}
          icon={<CarGreenSvg width={'1.2rem'} />}
          onClick={toggle}
        />

        <ModalButton
          backgroundColor={'#205c42'}
          color={'#fff'}
          text={'Misafirleri Görüntüle'}
          border={'1px solid #205c42'}
          margin={'.8rem 0 0 0'}
          icon={<HistoryIconSvg width={'1.2rem'} focus={true} />}
          onClick={() => {
            navigate('/hobiGuestProcess', {
              state: { selectedTesis: selectedTesis },
            })
          }}
        />
      </div>
    </div>
  )
}

export default SuccessModalBody
